export default __webpack_public_path__ + "images/et-cbe354bb4afa8afc62dabc80051f9577.svg";